import type {AppState} from 'src/store/typedef';

type GetAccountId = (state: AppState) => number;
export const getAccountId: GetAccountId = (state: AppState) => state.apiv2.accountId || NaN;
